export default __webpack_public_path__ + "static/as-554ea07913c16fff32476dd52293be06.svg";